"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return CalendarRange;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
let CalendarRange = class CalendarRange {
    static async bulkInsert(context, data, ncMeta = _Noco.default.ncMeta) {
        const calRanges = [];
        for (const d of data){
            const tempObj = (0, _extractProps.extractProps)(d, [
                'fk_from_column_id',
                'fk_view_id'
            ]);
            calRanges.push(tempObj);
        }
        if (!calRanges.length) return false;
        const insertObj = calRanges[0];
        const insertData = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, insertObj);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${insertData.fk_view_id}:list`, _globals.CacheDelDirection.PARENT_TO_CHILD);
        await _NocoCache.default.set(context, `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${insertData.id}`, insertData);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.CALENDAR_VIEW_RANGE, [
            insertData.fk_view_id
        ], `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${insertData.id}`);
        return true;
    }
    static async read(context, fk_view_id, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.CALENDAR_VIEW_RANGE, [
            fk_view_id
        ]);
        let { list: ranges } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !ranges.length) {
            ranges = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
                condition: {
                    fk_view_id
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.CALENDAR_VIEW_RANGE, [
                fk_view_id
            ], ranges.map((_0)=>{
                let { created_at, updated_at } = _0, others = _object_without_properties_loose(_0, [
                    "created_at",
                    "updated_at"
                ]);
                return others;
            }));
        }
        return (ranges == null ? void 0 : ranges.length) ? {
            ranges: ranges.map((_0)=>{
                let { created_at, updated_at } = _0, c = _object_without_properties_loose(_0, [
                    "created_at",
                    "updated_at"
                ]);
                return new CalendarRange(c);
            })
        } : null;
    }
    static async delete(rangeId, context, ncMeta = _Noco.default.ncMeta) {
        const range = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
            id: rangeId
        });
        if (!range) return false;
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, rangeId);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${range.fk_view_id}:list`, _globals.CacheDelDirection.PARENT_TO_CHILD);
        await _NocoCache.default.del(context, `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${rangeId}`);
        return true;
    }
    static async find(context, fk_view_id, ncMeta = _Noco.default.ncMeta) {
        const data = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
            fk_view_id
        });
        return data && new CalendarRange(data);
    }
    static async IsColumnBeingUsedAsRange(context, columnId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
            xcCondition: {
                _or: [
                    {
                        fk_from_column_id: {
                            eq: columnId
                        }
                    }
                ]
            }
        });
    }
    constructor(data){
        Object.assign(this, data);
    }
};
